/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';

import { authorizationOperations, setAccessTokenSilently, useAppDispatch } from '@Store';
import FullPageLoading from '../FullPageLoading/fullPageLoading';

const Auth0AuthenticationGuard = ({ component, token, email, refreshToken }) => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setAccessTokenSilently(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;

    const { updateTokenData } = authorizationOperations;
    dispatch(updateTokenData());
  }, [isLoading, isAuthenticated]);

  const Component = useMemo(
    () =>
      withAuthenticationRequired(component, {
        onRedirecting: () => <FullPageLoading />,
      }),
    [component],
  );

  return <Component />;
};

export default Auth0AuthenticationGuard;
